import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    root: {
        width: 300,
        fontFamily: 'Inter',
        fontStyle: 'normal',
        height: '100%',
        overflow: 'overlay',
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    sorting: {},
    facet: {}
});
